import { DataSource, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutUserQuickInfo extends Layout {
    sourceUsers: DataSource;
    textboxDepartmentId: Textbox;
    textboxEmailAddress: Label;
    textboxId: Textbox;
    textboxName: Textbox;
}
